export const MAXIMUM_NO_OF_ARRAY_ELEMENT = 4294967295;
export const SHIPPING_REF_MAX_LENGTH = 25;
